import {renderGlobalErrorMessage} from "./errors";
import {removeOverlay, showSubmittingOverlay} from "./overlay";
import {getRecaptchaFieldName, getRecaptchaSiteKey} from "./recaptcha";
import {initValidation} from "./validation";

export const handleFormSubmit = async (event : Event, bouncer) => {
  event.preventDefault();

  // Find the HTML elements
  const form = event.target as HTMLFormElement;
  const submitButton = form.querySelector('input[type="submit"], button[type="submit"]');
  const formContainer = submitButton.closest('div[data-leadform-id]');
  const actionUrl = form.getAttribute('data-action');

  if(bouncer.validateAll(form).length > 0) {
    console.log('found errors')
    return;
  }

  // Set the initial overlay
  const overlay = showSubmittingOverlay(formContainer);

  // Deactivate the submit button
  submitButton.setAttribute('disabled', 'disabled');

  // Process ReCAPTCHA
  const siteKey = getRecaptchaSiteKey(formContainer);
  const recaptchaResult = await grecaptcha.execute(siteKey, {action: 'lead'});
  const fieldId = getRecaptchaFieldName(formContainer);

  // Compile and submit the form
  const formData = new FormData(form);
  formData.set(fieldId, recaptchaResult);

  try {
    const response = await fetch(actionUrl, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const responseError = await response.json();
      renderGlobalErrorMessage(formContainer, responseError);
      throw new Error(responseError);
    }

    const responseJson = await response.json();
    await handleSubmitSuccessConfirmation(formContainer, responseJson);
  } catch (error) {
    removeOverlay(formContainer, overlay);
    formContainer.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  } finally {
    submitButton.removeAttribute('disabled');
  }
}

export const setSubmitListeners = (form : Element) => {
  const submitButton = form.querySelector('input[type="submit"], button[type="submit"]');
  if(!submitButton) {
    return;
  }

  const bouncer = initValidation(form);

  form.addEventListener('submit', async (e) => {
    // Prevents the form from submitting if the submit button is disabled
    if (submitButton && submitButton.hasAttribute('disabled')) {
      e.preventDefault();
      return;
    }

    await handleFormSubmit(e, bouncer);
  });
}

const handleSubmitSuccessConfirmation = (formContainer : Element, responseJson) => {
  if(responseJson.redirect_url) {
    window.location.href = responseJson.redirect_url;
    return;
  }

  if(responseJson.message) {
    formContainer.innerHTML = responseJson.message;
    formContainer.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }

  if ( typeof dataLayer !== 'undefined') {
    let leadObj = {
      'gaEventCategory': 'lead form',
      'gaEventAction':   'submission',
      'gaEventLabel':    responseJson.result || 'success',
      'event':           'leadFormSubmissionSuccess'
    };
    dataLayer.push(leadObj);
  }
}
